import { makeObservable } from 'mobx';
import { AssureAdminApiClientStore } from './assure-admin-api-client.store';
import { UploadFilesApiClient } from '../api';
import { AssureBaseStore, IAssureStoreConstructorOptions } from './assure-base.store';
import { ArtifactUploadFileType, IGetUploadedFileQuery, IUploadFileRequest, UploadFileCategory, UploadFileDto } from 'dto/upload-file.dto';


export type IUploadFilesStoreConstructorOptions = IAssureStoreConstructorOptions;

export class UploadFilesStore extends AssureBaseStore<UploadFilesApiClient, any> {

    private readonly _apiClientStore: AssureAdminApiClientStore;

    public constructor(
        options: IUploadFilesStoreConstructorOptions,
    ) {
        super(options);
        makeObservable(this);
        this._apiClientStore = options.apiClientStore;
    }

    protected get apiClient(): UploadFilesApiClient {
        return this._apiClientStore.apiClients.uploadFiles;
    }

    public async uploadFile(accountId: number, params: IUploadFileRequest, file: File): Promise<UploadFileDto> {
        const response = await this.apiClient.uploadFile(accountId, params, file);
        return new UploadFileDto(response.uploadedFile);
    }

    public async uploadArtifact(accountId: number, params: { description?: string; type: ArtifactUploadFileType }, file: File): Promise<UploadFileDto> {
        const response = await this.apiClient.uploadFile(accountId, { ...params, category: UploadFileCategory.ARTIFACT }, file);
        return new UploadFileDto(response.uploadedFile);
    }

    public async getUploadedFiles(accountId: number): Promise<UploadFileDto[]> {
        const response = await this.apiClient.getUploadedFiles(accountId, {
            category: UploadFileCategory.FTM,
            includeSharedFiles: true,
        });
        return response.uploadedFiles.map((uploadFile: any) => new UploadFileDto(uploadFile));
    }

    public async getArtifacts(accountId: number, query?: IGetUploadedFileQuery): Promise<UploadFileDto[]> {
        const response = await this.apiClient.getUploadedFiles(accountId, {
            category: UploadFileCategory.ARTIFACT,
            type: query?.type,
            offset: query?.offset,
            limit: query?.limit,
            includeSharedFiles: query?.includeSharedFiles,
        });
        return response.uploadedFiles.map((uploadFile: any) => new UploadFileDto(uploadFile));
    }
    public async deleteUploadedFile(accountId: number, uuid: string): Promise<boolean> {
        const response = await this.apiClient.deleteUploadedFile(accountId, uuid);
        return response?.deleted;
    }
}
